import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  current: {},
  list: [],
  tentative: {},
}

const requirementsSlice = createSlice({
  name: 'requirements',
  initialState,
  reducers: {
    setRequirementsList: (state, { payload }) => ({ ...state, list: [...payload.requirements] }),
    setCurrentRequirement: (state, { payload }) => ({ ...state, current: { ...payload.requirement } }),
    resetRequirementsState: () => ({ list: [], current: { messages: [] } })
  }
});

export const { setRequirementsList, setCurrentRequirement, resetRequirementsState } = requirementsSlice.actions;
export default requirementsSlice.reducer;
